import { makePostApiCall } from "../../shared/makeApiCall";

export async function restoreFromAudit(auditId) {
  return makePostApiCall("restoreFromAudit", { audit_id: auditId });
}
